import React from "react";
import { Card } from "../../../../shared/components/ui/Card";
import { InfoField } from "../../../../shared/components/ui/InfoField";
import type { Swimmer } from "../../../../api/client/types/swimmer.types";

interface SwimmerInfoCardProps {
  swimmer: Swimmer;
}

/**
 * SwimmerInfoCard
 * Component for displaying swimmer information in a consistent card format.
 * Used in both NewDetailContent and RegisterNewForm using the NewDetailContent format.
 */
export const SwimmerInfoCard: React.FC<SwimmerInfoCardProps> = ({ swimmer }) => {
  return (
    <Card variant="formSection">
      <h2 className="text-lg font-medium text-gray-800 mb-4">
        Información del Bañista
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <InfoField label="Nombre y apellido" value={swimmer.name} />
        <InfoField 
          label="Torre y apartamento" 
          value={`${swimmer.building_tower}-${swimmer.building_apartment}`} 
        />
        <InfoField
          label="Clasificación de edad"
          value={swimmer.age_classification?.name}
        />
        <InfoField
          label="Tipo de Bañista"
          value={swimmer.swimmer_type?.name}
        />
        <InfoField
          label="Responsable"
          value={swimmer.responsible?.name}
        />
      </div>
    </Card>
  );
};
